<template>
  <div>
    <naj-button
      v-if="type == actionType.serverAction"
      v-bind="attrs"
      @click="$emit('click-action')"
    >
      <slot />
    </naj-button>

    <naj-button
      v-if="type == actionType.popup || type == actionType.addNew || type == actionType.edit"
      v-bind="attrs"
      @click="$emit('open-popup')"
    >
      <slot />
    </naj-button>

    <naj-button
      v-if="type == actionType.delete"
      v-bind="attrs"
      color="error"
      @click="$emit('open-delete-popup')"
    >
      <slot />
    </naj-button>

    <naj-button
      v-if="type == actionType.redirect"
      v-bind="attrs"
      :to="url"
    >
      <slot />
    </naj-button>

    <naj-button
      v-if="type == actionType.redirectToNewTab || type == actionType.gridPrinting"
      v-bind="attrs"
      :to="url"
      target="_blank"
    >
      <slot />
    </naj-button>
  </div>
</template>

<script>
import { actionType } from '@/helpers/enum';

export default {
  name: 'NajActionButton',
  inheritAttrs: true,
  props: {
    type: { required: true },
    url: { required: false },
  },
  data() {
    return { actionType };
  },
  computed: {
    attrs() {
      const { ...attrs } = this.$attrs;
      return attrs;
    },
  },
};
</script>
